<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: ImageLibrary - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" id="image_library">
    <div class="mt-6 flex items-center justify-between px-6" >
        <span class="flex items-center justify-center">
        <h4>MENU VIEW</h4>
        </span>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

  <div class="p-6">
    <div id="food_menu" ref="food_menu">
    <section class="pages" id="menu" >
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <h2>Weekly Menu</h2>
                <div>
                    <div class="col-md-12" v-for="item in Menu" :key="item.id">
                        <h3>{{item.name}}</h3>
                        <div class="menu_cal breakfast fc fc-ltr">
                            <table class="fc-header" style="width:100%">
                                <tbody>
                                    <tr>
                                        <td class="fc-header-left"><span class="fc-header-title">
                                                <!-- <h6>Oct 4 — 8 2021</h6> -->
                                            </span></td>
                                        <td class="fc-header-center"></td>
                                        <td class="fc-header-right"><span
                                                class="fc-button fc-button-today fc-state-default fc-corner-left fc-corner-right fc-state-disabled"
                                                unselectable="on" style="display: none;">today</span><span
                                                class="fc-header-space"></span><span
                                                class="fc-button fc-button-prev fc-state-default fc-corner-left"
                                                unselectable="on" style="display: none;"><span
                                                    class="fc-text-arrow">‹</span></span><span
                                                class="fc-button fc-button-next fc-state-default fc-corner-right"
                                                unselectable="on" style="display: none;"><span
                                                    class="fc-text-arrow">›</span></span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="fc-content" style="position: relative;">
                                <div class="fc-view fc-view-basicWeek fc-grid" style="position:relative"
                                    unselectable="on">
                                    <div class="fc-event-container" style="position:absolute;z-index:8;top:0;left:0" >
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 2px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[0].value}}</span></div>
                                        </div>
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 218px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[1].value}}</span></div>
                                        </div>
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 434px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[2].value}}</span></div>
                                        </div>
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 650px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[3].value}}</span>
                                            </div>
                                        </div>
                                        <div class="fc-event fc-event-hori fc-event-start fc-event-end"
                                            style="position: absolute; left: 866px; width: 212px; top: 54px;">
                                            <div class="fc-event-inner"><span class="fc-event-title">{{item.days[4].value}}</span></div>
                                        </div>
                                    </div>
                                    <table class="fc-border-separate" style="width:100%" cellspacing="0">
                                        <thead>
                                            <tr class="fc-first fc-last">
                                                <th class="fc-day-header fc-mon fc-widget-header fc-first" :key="index" v-for="(day,index) in item.days" v-if="index<5"
                                                    style="width: 216px;">{{day.day.charAt(0).toUpperCase()+day.day.charAt(1).toUpperCase()+day.day.charAt(2).toUpperCase()}} {{day.date}}</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="fc-week fc-first fc-last">
                                                <td class="fc-day fc-mon fc-widget-content fc-past fc-first"
                                                    data-date="2021-10-04">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="fc-day fc-tue fc-widget-content fc-past"
                                                    data-date="2021-10-05">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="fc-day fc-wed fc-widget-content fc-past"
                                                    data-date="2021-10-06">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="fc-day fc-thu fc-widget-content fc-past"
                                                    data-date="2021-10-07">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="fc-day fc-fri fc-widget-content fc-today fc-state-highlight fc-last"
                                                    data-date="2021-10-08">
                                                    <div>
                                                        <div class="fc-day-content">
                                                            <div style="position: relative; height: 33px;">&nbsp;</div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</div>
         </div>
    </component>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  program_temp,
} from "./../ProgramTemplate";

import {
    MAKE_FOOD_MENU
} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    VuePerfectScrollbar,
 

  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      weeks:[],
      Menu:[],
        main:program_temp,
   

    }
  },
  watch: {
    isSidebarActive (val) {
      if(val){
          this.getMenu(this.$route.params.siteName)
      }
      if(val){
             
               
              //  let doc = new DOMParser().parseFromString(this.main, "text/html");
              //  var d1 = doc.getElementsByTagName("NAV")[0];
              //  d1.insertAdjacentHTML('afterend', this.$refs.page_data.innerHTML);
              //  this.$emit('setStaffTemplate',doc.documentElement.outerHTML)
               
          }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() 
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
     createMenu(){
        let doc = new DOMParser().parseFromString(this.main, "text/html");
               var d1 = doc.getElementsByTagName("NAV")[0];
               d1.insertAdjacentHTML('afterend', this.$refs.food_menu.innerHTML);
        console.log(doc.documentElement.outerHTML)
     },
     getMenu(site){
      this.$apollo
        .mutate({
          mutation: MAKE_FOOD_MENU,
          variables: {
            site:site
          }
        })
        .then(response => {
          if(response.data.makeFoodMenu.status==='Success'){
            this.Menu =JSON.parse(response.data.makeFoodMenu.data);
              this.$nextTick(() => {
                  this.createMenu()
                })
            
          }
        }).catch(error => {
          console.log(error)
        })
     },
  },

}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 1000px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
.ownsidebar{
    width:100px !important;
    max-width:257px !important;
}
</style>
<style>
.vs-tooltip{
  z-index: 99999 ;
}
</style>
